<div class="print-ticket center" *ngIf="ticketPrint">
    <div class="print-content">
        <ng-container *ngIf="enviroment.viewConfiguration === siteViewConfigurationEnum.NIGERIA; else admiral">
            <img src="assets/img/wgb-logo.png" alt="Logo">
            <!-- <img src="assets/img/wgb-print-logo-nolink.svg" alt="Logo"> -->
        </ng-container>
        <ng-template #admiral>
            <img src="assets/img/admiral-print-logo.svg" alt="Logo">
        </ng-template>


        <div class="ticket-top">
            <span>{{tmUser?.loggedOffice.name}}</span>
            <span *ngIf="affiliate?.worksInShop">
              <ng-container >
                Shop
              </ng-container>
              : {{affiliate.worksInShop?.name}}</span>
            <span *ngIf="affiliate?.firstName || affiliate?.lastName">
              <ng-container i18n="TM Cashier@@Cashier">
                Cashier
              </ng-container>
              : {{affiliate?.username}} </span>
            <!-- : {{affiliate?.firstName}} {{affiliate?.lastName}}</span> -->
            <!-- <span>Novi Sad</span> -->
            <span>
              <ng-container i18n="TM Date and Time@@DateAndTime">Date and Time</ng-container>
              : {{ticketPrint.updatedDateTime| date:"dd.LL.YYYY. HH:mm:ss"}}</span>
            <div class="ticket-id">
                <span class="bold">
                  <ng-container i18n="TM Ticket ID@@TicketID">Ticket ID</ng-container>
                  : {{ticketPrint.ticketId}}</span>
                <span class="bold">
                  <ng-container i18n="TM Pin@@Pin">
                    Pin
                  </ng-container>: {{ticketPrint.pinCode}}</span>
            </div>
        </div>
        <div class="line"></div>
        <div class="ticket-items">
            <div class="item-wrap" *ngFor="let ticketItemGroup of ticketPrint.ticketItemGroups; let i = index">
                <div class="item small">
                    <div class="region-wrap">
                        <span>{{i+1}}) </span> <span>{{ticketItemGroup.regionName}} - {{ticketItemGroup.competitionName}}</span>
                    </div>
                    <div class="time-wrap">
                        <span>{{ticketItemGroup.eventDateTime | date:"dd.LL. HH:mm"}}</span>
                    </div>
                </div>
                <div class="item">
                    <div class="code-wrap">
                        <span class="bold">{{ticketItemGroup.eventCode}}</span>
                        <span>
                            <ng-container *ngIf="ticketItemGroup.isInBankersGroup">B</ng-container>
                            <ng-container *ngIf="!ticketItemGroup.isInBankersGroup && ticketPrint.systems.length == 1">S</ng-container>
                            <ng-container *ngIf="!ticketItemGroup.isInBankersGroup && ticketPrint.systems.length > 1">SS</ng-container>
                            <span class="live" *ngIf="ticketItemGroup.isLive">L</span>

                        </span>
                    </div>
                    <div class="event-name-wrap">
                        <div class="event">
                            <span class="bold">
                                {{ticketItemGroup.eventName}}
                                <ng-container *ngIf="ticketItemGroup.mappingType == eventMappingTypeEnum.SuperBetEvent"> ({{dynamicTranslations.specialOfferEventsShorcutSuperBet}})</ng-container>
                                <ng-container *ngIf="ticketItemGroup.mappingType == eventMappingTypeEnum.EventOfDay"> ({{dynamicTranslations.specialOfferEventsShorcutEventOfDay}})</ng-container>
                            </span>
                            <span class="odd"></span>
                        </div>
                        <div class="event" *ngFor="let ticketItem of ticketItemGroup.ticketItems">
                            <div class="outcome-wrap">
                                {{ticketItem.betTypeName}} - 
                                <span class="bold">
                                    {{ticketItem.betTypeOutcomeName}} 
                                    <ng-container *ngIf="ticketItem.sbv">({{ticketItem.sbv}})</ng-container>
                                </span>
                            </div>
                            <span class="time-wrap bold">{{ticketItem.odd | odd}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="line"></div>
        <div class="ticket-bottom">
            <div class="item bold divider" *ngIf="ticketPrint.systemItemsCount > 0">
                <ng-container *ngIf="ticketPrint.fixItemsCount > 1">
                    <ng-container i18n="TM Fix@@Fix">
                        Fix
                    </ng-container>
                    {{ticketPrint.fixItemsCount}} , </ng-container>
                <ng-container *ngIf="ticketPrint.systems.length > 0">
                    <ng-container i18n="System text@@myTicketSystemSystem">System</ng-container>&nbsp;
                    <ng-container *ngFor="let sistem of ticketPrint.systems; let i = index">
                        <ng-container *ngIf="i>0">,</ng-container>{{sistem}}</ng-container>/{{ticketPrint.systemItemsCount}}
                </ng-container>
            </div>
            <div class="divider">
                <div class="item">
                    <span class="upper"><ng-container i18n="Number of combinations ticket calculator@@NumberOfCombinatuions">NUMBER OF COMBINATIONS</ng-container> :</span>
                    <span>{{ticketPrint.numOfCombinations}}</span>
                </div>
                <div class="item">
                    <span class="upper"><ng-container i18n="Total Odd ticket calculator@@TotalOdd">TOTAL ODD</ng-container> :</span>
                    <span>{{ticketPrint.totalOdd | number: '1.2-2' }}</span>
                </div>
            </div>
            <div class="item payin" [class.divider]="ticketPrint.taxBeforeStake === 0 && (ticketPrint.bonus > 0 || ticketPrint.possibleMinPayout > 0)">
                <span class="upper"><ng-container i18n="Ticket Pay in text@@TicketPayIn">PAYIN</ng-container> :</span>
                <span>{{ticketPrint.payin}} {{CV.CURRENCY}}</span>
            </div>

            <div class="item" *ngIf="ticketPrint.taxBeforeStake > 0" [class.divider]="ticketPrint.bonus > 0 || ticketPrint.taxBeforeStake > 0">
                <span class="upper"><ng-container i18n="Tax on payin@@TaxOnPayin">Porez na uplatu</ng-container> :</span>
                <span>{{ticketPrint.taxBeforeStake}} {{CV.CURRENCY}}</span>
            </div>

            <!-- <div class="item" [class.divider]="ticketPrint.bonus > 0" *ngIf="ticketPrint.possibleMinPayout > 0">
                <span class="upper"><ng-container i18n="Min possible win ticket calculator@@MinPossibleWin">MIN WINNINGS</ng-container> :</span>
                <span>{{ticketPrint.possibleMinPayout | number: '1.2-2'}} {{CV.CURRENCY}}</span>
            </div> -->


            <div class="item" *ngIf="ticketPrint.bonus > 0">
                <span class="upper"><ng-container i18n="TM MAX BONUS@@MAXBONUS">MAX BONUS</ng-container> :</span>
                <span>{{ticketPrint.bonus | number: '1.2-2'}} {{CV.CURRENCY}}</span>
            </div>
            <div class="item bold" [class.divider]="ticketPrint.bonus > 0 && ticketPrint.taxOnWinning === 0 && !showMinPayout" *ngIf="ticketPrint.possibleWin > 0">
                <span class="upper"><ng-container i18n="Max possible win ticket calculator@@PossibleWin">POTENTIAL WINNINGS</ng-container> :</span>
                <span>{{ticketPrint.possibleWin | number: '1.2-2'}} {{CV.CURRENCY}}</span>
            </div>

            <div class="item bold" [class.divider]="ticketPrint.bonus > 0 && ticketPrint.taxOnWinning === 0" *ngIf="showMinPayout">
                <span class="upper"><ng-container i18n="Min possible payout shorted@@MinPossiblePayoutShorted">MIN PAYOUT</ng-container> :</span>
                <span>{{ticketPrint.possibleMinPayout | number: '1.2-2'}} {{CV.CURRENCY}}</span>
            </div>

            <div class="item divider" *ngIf="ticketPrint.taxOnWinning > 0">
                <span class="upper"><ng-container i18n="Tax on winnings@@TaxOnWinings">Porez</ng-container> :</span>
                <span>{{ticketPrint.taxOnWinning | number: '1.2-2'}} {{CV.CURRENCY}}</span>
            </div>
        </div>
        <div class="line upper" i18n="Max possible payout shorted@@MaxPossiblePayoutShorted">MAX WINNINGS</div>
        <div class="win">{{ticketPrint.possibleWinWithoutTax | number: '1.2-2'}} <span>{{CV.CURRENCY}}</span></div>
        <div class="line big"></div>
        <ngx-barcode6  [bc-format]="'MSI'" [bc-value]="ticketPrint.ticketId + '' + ticketPrint.pinCode" [bc-display-value]="true" [bc-height]="75" [bc-font]="'Calibri'" [bc-margin]="0"></ngx-barcode6>
        <div class="info-footer"><span i18n="Ticket Validity info@@ticketValidityInfo">*Winning ticket Validity is 7 days.</span></div>
    </div>
</div>
<div class="print-ticket center" *ngIf="fastTicketCode">
    <div class="print-content">
        <ng-container *ngIf="enviroment.viewConfiguration === siteViewConfigurationEnum.NIGERIA else admiral">
            <img src="assets/img/wgb-logo.png" alt="Logo">
            <!-- <img src="assets/img/wgb-print-logo-nolink.svg" alt="Logo"> -->
        </ng-container>
        <ng-template #admiral>
            <img src="assets/img/admiral-print-logo.svg" alt="Logo">
        </ng-template>
        <div class="ticket-top">
            <span>
                <ng-container i18n="TM Date and Time@@DateAndTime">Date and Time</ng-container>: {{date | date:"dd.LL.YYYY. HH:mm:ss"}}
            </span>
        </div>
        <div class="line"></div>
        <div class="ticket-code">
            <span>{{fastTicketCode}}</span>
        </div>
        <div class="line big"></div>
        <ngx-barcode6  [bc-format]="'MSI'" [bc-value]="fastTicketCode" [bc-display-value]="true" [bc-height]="75" [bc-font]="'Calibri'" [bc-margin]="0"></ngx-barcode6>
    </div>
</div>